import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import classes from "../../assets/css/CustomerDetails.module.css";
import { Col, Container, Row } from "reactstrap";
function ViewCustomer({
  orderViewState,
  handleClose,
  handleOrderStatusValue,
  handleDateFormat,
}) {
  return (
    <Dialog
      open={orderViewState.isViewDialogOpen}
      onClose={handleClose}
      PaperProps={{
        style: {
          backgroundColor: "#fadf9e",
          overflow: "auto",
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle
        className={`accordionHeaderColor ${classes["view_icon_cross"]}`}
      >
        View Details
        <i
          onClick={handleClose}
          className={`fa-solid fa-xmark ${classes["cursor_style"]}`}
        ></i>
      </DialogTitle>
      <DialogContent dividers className="px-0 px-sm-3 px-md-4">
        <div className={`popupForm-holder ${classes["view_content_customer"]}`}>
          {orderViewState.isViewDialogOpen && (
            <Container>
              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Order Id:</b>
                    <p className="accordionHeaderColor">
                      {" "}
                      {orderViewState.orderViewData.order.orderId
                        ? orderViewState.orderViewData.order.orderId
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Customer Id:</b>
                    <p className="accordionHeaderColor">
                      {" "}
                      {orderViewState.orderViewData.customerData.customer
                        .customerId
                        ? orderViewState.orderViewData.customerData.customer
                            .customerId
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className={classes["horizontal_line_view"]} />
              <>
                {" "}
                <Row>
                  {/* <Col lg="6" md="12">
                    <div className={classes["view_details_content"]}>
                      <b className="darkText">App Id:</b>
                      <p className="accordionHeaderColor">
                        {" "}
                        {orderViewState.orderViewData.order.app_id
                          ? orderViewState.orderViewData.order.app_id
                          : "--"}
                      </p>
                    </div>
                  </Col> */}
                  {/* <Col lg="6" md="12">
                    <div className={classes["view_details_content"]}>
                      <b className="darkText">Status:</b>
                      <p className="accordionHeaderColor">
                        {" "}
                        {orderViewState.orderViewData.order.orderType
                          ? handleOrderStatusValue(
                              orderViewState.orderViewData.order
                            )
                          : "--"}
                      </p>
                    </div>
                  </Col> */}
                   <Col lg="6" md="12">
                    <div className={classes["view_details_content"]}>
                      <b className="darkText">Order Date:</b>
                      <p className="accordionHeaderColor">
                        {orderViewState.orderViewData.order?.dateCreated
                          ? handleDateFormat(
                              orderViewState.orderViewData.order?.dateCreated
                            )
                          : "--"}
                      </p>
                    </div>
                  </Col>
                </Row>
                {/* <hr className={classes["horizontal_line_view"]} />
                <Row>
                  <Col lg="6" md="12">
                    <div className={classes["view_details_content"]}>
                      <b className="darkText">Order Date:</b>
                      <p className="accordionHeaderColor">
                        {orderViewState.orderViewData.order?.dateCreated
                          ? handleDateFormat(
                              orderViewState.orderViewData.order?.dateCreated
                            )
                          : "--"}
                      </p>
                    </div>
                  </Col>
                  {orderViewState.orderViewData.order.orderType ===
                    "CANCEL" && (
                    <Col lg="6" md="12">
                      <div className={classes["view_details_content"]}>
                        <b className="darkText">Cancel Date:</b>
                        <p className="accordionHeaderColor">
                          {orderViewState.orderViewData.order?.cancelDate
                            ? handleDateFormat(
                                orderViewState.orderViewData.order?.cancelDate
                              )
                            : "--"}
                        </p>
                      </div>
                    </Col>
                  )}
                  {orderViewState.orderViewData.order.orderType ===
                    "REFUND" && (
                    <Col lg="6" md="12">
                      <div className={classes["view_details_content"]}>
                        <b className="darkText">Refund Date:</b>
                        <p className="accordionHeaderColor">
                          {orderViewState.orderViewData.order?.refundDate
                            ? handleDateFormat(
                                orderViewState.orderViewData.order?.refundDate
                              )
                            : "--"}
                        </p>
                      </div>
                    </Col>
                  )}
                </Row> */}
                {/* <hr className={classes["horizontal_line_view"]} />
                <Row>
                  <Col lg="12" md="12">
                    <div className={classes["view_details_content"]}>
                      <b className="darkText">Ip Address:</b>
                      <p className="accordionHeaderColor">
                        {orderViewState.orderViewData.customerData.customer
                          .ipAddress
                          ? orderViewState.orderViewData.customerData.customer
                              .ipAddress
                          : "--"}
                      </p>
                    </div>
                  </Col>
                </Row> */}
                <hr className={classes["horizontal_line_view"]} />
              </>

              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">First Name:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData.customer
                        .firstName
                        ? orderViewState.orderViewData.customerData.customer
                            .firstName
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Last Name:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData.customer
                        .lastName
                        ? orderViewState.orderViewData.customerData.customer
                            .lastName
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className={classes["horizontal_line_view"]} />

              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Phone:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData.customer.phone
                        ? orderViewState.orderViewData.customerData.customer
                            .phone
                        : "--"}
                    </p>
                  </div>
                </Col>

                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Email:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData.customer.email
                        ? orderViewState.orderViewData.customerData.customer.email?.includes(
                            "mailto:"
                          )
                          ? orderViewState.orderViewData.customerData.customer?.email?.slice(
                              7
                            )
                          : orderViewState.orderViewData.customerData.customer
                              ?.email
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>

              <hr className={classes["horizontal_line_view"]} />
              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Address1:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address
                        ?.address1
                        ? orderViewState.orderViewData.customerData?.address
                            ?.address1
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Address2:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address
                        ?.address2
                        ? orderViewState.orderViewData.customerData?.address
                            ?.address2
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className={classes["horizontal_line_view"]} />
              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">City:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address?.city
                        ? orderViewState.orderViewData.customerData?.address
                            ?.city
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">State:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address?.state
                        ? orderViewState.orderViewData.customerData?.address
                            ?.state
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className={classes["horizontal_line_view"]} />
              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Zip Code:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address
                        ?.postalCode
                        ? orderViewState.orderViewData.customerData?.address
                            ?.postalCode
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Country:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.address
                        ?.country
                        ? orderViewState.orderViewData.customerData?.address
                            ?.country
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row>
              {/* <hr className={classes["horizontal_line_view"]} /> */}
              {/* <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Campaign Id:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.campaign
                        ?.campaignId
                        ? orderViewState.orderViewData.customerData?.campaign
                            ?.campaignId
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Campaign Name:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData?.campaign
                        ?.campaignName
                        ? orderViewState.orderViewData.customerData?.campaign
                            ?.campaignName
                        : "--"}
                    </p>
                  </div>
                </Col>
              </Row> */}
              <hr className={classes["horizontal_line_view"]} />
              <Row>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Order Total ($):</b>
                    <p className="accordionHeaderColor">
                      {" "}
                      {orderViewState.orderViewData.order?.orderTotal !== "" &&
                      orderViewState.orderViewData.order?.orderTotal != null
                        ? orderViewState.orderViewData.order?.orderTotal
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" md="12">
                  <div className={classes["view_details_content"]}>
                    <b className="darkText">Subscription Status:</b>
                    <p className="accordionHeaderColor">
                      {orderViewState.orderViewData.customerData
                        ?.subscription_status
                        ?  orderViewState.orderViewData.customerData?.subscription_status
                        : "--"} 
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ViewCustomer;
